import React from 'react';


function EmptyTaskResults({
                              title = 'Oops! No Tasks Found',
                              description = 'There is no task to display at the moment. Please add new tasks to get started.',
                          }) {
    return (
        <div className="flex justify-center rounded-xl border border-[var(--border-color)] bg-[var(--surface-deep)] px-6 shadow-sm">
            <div className="w-full max-w-md px-8 py-10 text-center">
                <h1 className="mb-4 text-3xl font-semibold text-[var(--text-primary)]">{title}</h1>
                <p className="text-base text-[var(--text-secondary)]">{description}</p>
            </div>
        </div>
    );
}

export default EmptyTaskResults;
